<template>
  <div class="_card">
    <el-card style="padding: 0px; color: rgb(244, 244, 244);">
      <img :src="item.avatar" class="review-user" />
      <div>
        <div class="reviews-user">{{ item.email }}</div>
        <div class="reviews-from">{{ item.pov }}</div>
        <div class="reviews-detail clearfix" style="color: rgb(142, 129, 158);">
          {{ item.comments }}
          - <time class="time">{{ item.timeDesc }}</time>
        </div>
        <div class="reviews-rate">
          <div class="reviews-rate-text" style="color: rgb(142, 129, 158);">
            <p>用户评分</p>
            <el-rate disabled allow-half v-model="item.rank"></el-rate>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
._card {
  @media screen and (max-width: 992px) {
    margin: 0 5px !important;
    /deep/ .el-card__body{
      padding:5px 2px!important;
    }
    .reviews-rate {
      margin-top: 20px !important;
    }
    // .reviews-detail{
    //   height: 60px!important;
    // }
  }
  margin: 0 20px;
  /deep/ .el-card {
    background-color: rgba(255, 255, 255, 0.02);
    border-color: transparent;
    text-align: center;
    margin-bottom: 10px;
  }
}
.review-user {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  -webkit-box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
  box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
}
.reviews-user {
  font-size: 14px;
  margin-top: 12px;
}
.reviews-from {
  font-size: 8px;
  color: #069;
  margin-top: 8px;
}
.reviews-detail {
  font-size: 12px;
  margin-top: 16px;
  margin-bottom: 20px;
  height: 100px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.reviews-rate {
  margin-top: 20px;
  .reviews-rate-text {
    font-size: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card.vue